export enum LangNamespaceEnum {
  SHARED = 'shared',
  ADMIN_UI_COMMON = 'adminUICommon',
}
